import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesProducts } from "../../constants";
import {
  ProductLifetimeStatsRequestParams,
  ProductLifetimeStatsResponse
} from "./getProductLifetimeStats.types";

export const requestGetProductLifetimeStats = async (
  productId: string,
  params: ProductLifetimeStatsRequestParams
): Promise<ProductLifetimeStatsResponse> => {
  return await instance.get(buildUrl(ApiRoutesProducts.LifetimeStats, productId), {
    params
  });
};
